<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    @change="handleChange"
    :loading="loading"
    placeholder="请选择服务产品"
    style="width: 100%"
    :popper-append-to-body="true"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { maintainanceRuleList } from '@/service/getData'

export default {
  props: {
    value: '',
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData() {
      this.loading = true
      let res = await maintainanceRuleList({})
      this.loading = false
      this.lists = res.data.list
    },
  },
}
</script>